<template> <!-- 色変更(青) 子コンポーネント -->
  <div id="setblue" >
    <td :style="{background:blue[0]}" height="55" @click="setBlue(0)"></td>
    <td :style="{background:blue[1]}" @click="setBlue(1)"></td>
    <td :style="{background:blue[2]}" @click="setBlue(2)"></td>
    <td :style="{background:blue[3]}" @click="setBlue(3)"></td>
    <td :style="{background:blue[4]}" @click="setBlue(4)"></td>
    <td :style="{background:blue[5]}" @click="setBlue(5)"></td>
    <td :style="{background:blue[6]}" @click="setBlue(6)"></td>
    <td :style="{background:blue[7]}" @click="setBlue(7)"></td>
    <td :style="{background:blue[8]}" @click="setBlue(8)"></td>
    <td :style="{background:blue[9]}" @click="setBlue(9)"></td>
    <td :style="{background:blue[10]}" @click="setBlue(10)"></td>
    <td :style="{background:blue[11]}" @click="setBlue(11)"></td>
    <td :style="{background:blue[12]}" @click="setBlue(12)"></td>
    <td :style="{background:blue[13]}" @click="setBlue(13)"></td>
    <td :style="{background:blue[14]}" @click="setBlue(14)"></td>
  </div>
</template>

<script>
export default {
  name: 'SetBlue',
  data () {
    return {
      bg_color: ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '']
    }
  },
  props: {
    blue: Array,
    index: Number
  },

  methods: {
    setBlue: function (num) {
      this.$emit('set-blue', num, this.index)
    },
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
